import { connect } from 'react-redux';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import config from '../../config';
import React, { useEffect, useState, useRef } from 'react';
import './FashionPagination.scss';

const FashionPagination = (props) => {
  const { pageSize = 10, total, currentPage, clickPagination } = props;

  const totalPages = Math.ceil(total / pageSize) || 1;

  const getDisplayPages = () => {
    const pages = [];
    const minPagesForDots = 6;
    const middlePagesCount = 3;

    if (totalPages <= minPagesForDots) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    pages.push(1);

    let start = currentPage - Math.floor(middlePagesCount / 2);
    start = Math.min(Math.max(start, 2), totalPages - middlePagesCount);

    if (start > 2) pages.push('dot');

    for (let i = start; i < start + middlePagesCount; i++) {
      pages.push(i);
    }

    if (start + middlePagesCount < totalPages) pages.push('dot');

    pages.push(totalPages);

    return pages;
  };

  const handlePageChange = (page) => {
    if (page < 1) {
      page = 1;
    } else if (page > totalPages) {
      page = totalPages;
    }

    if (page !== currentPage) {
      clickPagination(page, (page - 1) * pageSize, page * pageSize);
    }
  };

  return (
    <div className="fashion-pagination">
      <Pagination>
        <PaginationItem>
          <div className="arrows" onClick={() => handlePageChange(1)}>
            {'\u00AB'}
          </div>
        </PaginationItem>
        <PaginationItem>
          <div className="arrows" onClick={() => handlePageChange(currentPage - 1)}>
            {'\u2039'}
          </div>
        </PaginationItem>
        {getDisplayPages().map((page, index) => (
          <PaginationItem key={index} active={page === currentPage}>
            {typeof page === 'number' ? (
              <div className="num-item" onClick={() => handlePageChange(page)}>
                {page}
              </div>
            ) : (
              <div className="arrows dot">{'\u00B7\u00B7\u00B7'}</div>
            )}
          </PaginationItem>
        ))}
        <PaginationItem>
          <div className="arrows" onClick={() => handlePageChange(currentPage + 1)}>
            {'\u203A'}
          </div>
        </PaginationItem>
        <PaginationItem>
          <div className="arrows" onClick={() => handlePageChange(totalPages)}>
            {'\u00BB'}
          </div>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default FashionPagination;
